import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "impx-slideshow uk-margin-large-top" }
const _hoisted_2 = {
  class: "uk-position-relative uk-visible-toggle uk-light uk-height-1-1",
  "data-uk-slideshow": "min-height: 220; max-height: 660; animation: fade"
}
const _hoisted_3 = { class: "uk-slideshow-items" }
const _hoisted_4 = { class: "uk-position-cover uk-animation-kenburns uk-animation-reverse uk-transform-origin-center-left" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "impx-slide-caption uk-box-shadow-small" }
const _hoisted_7 = { class: "uk-margin-remove impx-text-gold" }
const _hoisted_8 = { class: "impx-text-large uk-margin-remove impx-text-aqua" }
const _hoisted_9 = { class: "uk-dotnav uk-dotnav-contrast uk-flex-center uk-position-z-index impx-slide-nav" }


const baseUrls = "https://strapi.citesainteaugustine-ci.com"

export default /*@__PURE__*/_defineComponent({
  __name: 'EventActivitiesCaroussel',
  props: {
  carrouselElement:{type:Array, default: ()=> []}
},
  setup(__props) {

const props = __props;
console.log(props.carrouselElement)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.carrouselElement, (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: baseUrls+item?.slideImage?.url??'',
                alt: "",
                class: "slide 1",
                "data-uk-cover": ""
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(item.title), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(item.subtitle), 1)
            ])
          ]))
        }), 128))
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("a", {
        class: "uk-position-center-left uk-position-small uk-hidden-hover",
        href: "#",
        "data-uk-slidenav-previous": "",
        "data-uk-slideshow-item": "previous"
      }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("a", {
        class: "uk-position-center-right uk-position-small uk-hidden-hover",
        href: "#",
        "data-uk-slidenav-next": "",
        "data-uk-slideshow-item": "next"
      }, null, -1)),
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.carrouselElement, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            "data-uk-slideshow-item": "{{index}}",
            key: index
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("a", { href: "#" }, null, -1)
          ]))]))
        }), 128))
      ])
    ])
  ]))
}
}

})